import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'date-time-format-timezone/build/browserified/date-time-format-timezone-all-zones-no-locale-min';
import "reflect-metadata";
import React from 'react';
import { createRoot } from 'react-dom/client';
import TripPlannerApp from "./app/TripPlannerApp";

const root = createRoot(document.getElementById("tripgo-planner")!);
root.render(<TripPlannerApp />);